import {
    USERS_READ_FROM_FORAGE,
    USERS_FORGET_USERS,
    USERS_LOGIN_USER,
    USERS_LOGOUT_USER,
    USERS_SET_USER_PINNED_STATE,
    USERS_SET_USER_MULTILAUNCH_STATE,
    USERS_SET_USER_ACCESSTOKEN,
    USERS_SET_USER_PROFILE,
    USERS_SET_AUTOLAUNCH,
    USER_SET_ORDER,
} from '../constants'

// Update the list of users from the forage
export function actionUsersReadFromForage(users) {
    return {
        type: USERS_READ_FROM_FORAGE,
        payload: users,
    }
}

// Update the order of users
export function actionUserSetOrder(server, order) {
    return {
        type: USER_SET_ORDER,
        payload: { server, order },
    }
}

// Forget users
export function actionUsersForgetUsers() {
    return {
        type: USERS_FORGET_USERS,
    }
}

// Update a users accessToken
export function actionUsersSetUserAccessToken(server, userKey, accessToken) {
    return {
        type: USERS_SET_USER_ACCESSTOKEN,
        payload: {
            server,
            userKey,
            accessToken,
        },
    }
}

// Update a users profile
export function actionUsersSetUserProfile(server, userKey, profile) {
    return {
        type: USERS_SET_USER_PROFILE,
        payload: {
            server,
            userKey,
            profile,
        },
    }
}

// Add user to list of users
export function actionUsersLogInUser(server, user) {
    return {
        type: USERS_LOGIN_USER,
        payload: {
            server,
            user,
        },
    }
}

// Remove user from list of users
export function actionUsersLogOutUser(server, userKey) {
    return {
        type: USERS_LOGOUT_USER,
        payload: {
            server,
            userKey,
        },
    }
}

// Toggle users pin state
export function actionUsersSetUserPinnedState(server, userKey, pinned) {
    return {
        type: USERS_SET_USER_PINNED_STATE,
        payload: {
            server,
            userKey,
            pinned,
        },
    }
}

// Toggle users multi-launch state
export function actionUsersSetUserMultiLaunchState(server, userKey, multiLaunch) {
    return {
        type: USERS_SET_USER_MULTILAUNCH_STATE,
        payload: {
            server,
            userKey,
            multiLaunch,
        },
    }
}

// Change state of autolaunch for user
export function actionUsersSetUserAutoLaunchState(server, userKey, autoLaunch) {
    return {
        type: USERS_SET_AUTOLAUNCH,
        payload: {
            server,
            userKey,
            autoLaunch,
        },
    }
}



// WEBPACK FOOTER //
// ./src/actions/users.js